
import { Button } from '../componentes/Button'
import '../styles/home.scss'
import { Candidata } from '../componentes/Candidata'
import { useNavigate } from 'react-router-dom'
import { useCandidata } from '../hooks/useCandidata'
import { FooterCandidataVote } from '../componentes/FooterCandidataVote'
import { Header } from '../componentes/Header'

export function Vote() {
    const history = useNavigate()
    const { candidata } = useCandidata()

    function voltar() {
        history('/')
    }
    return (
        <div id="page-room">
            <Header />
            <main className='content'>
                <div className='room-title'>
                    <Button onClick={voltar}>Home</Button>
                </div>
                <div className='question-list'>
                    <div className='list-flex'>
                        <Candidata key={candidata?.id}
                            content={candidata}>
                            <FooterCandidataVote candidata={candidata} />
                        </Candidata>

                    </div>
                </div>

            </main>
        </div>
    )
}